import * as actions from "./actionsType";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,

  loadingFactorCriterion: false,
  saveLoadingFactorCriterion: false,
  
  loadingOrganizationalUnit: false,
  saveLoadingOrganizationalUnit: false,

  responsiblesFactorsLength: 0,
  responsiblesFactors: [],
  responsibleFactor: {},
  responsibleFactorError: "",

  formError: "",
  factorsCriteriaLength: 0,
  factorsCriteria: [],
  factorCriterion: {},
  factorCriterionError: "",
  organizationalUnits: [],
  organizationalUnit: {},
  organizationalUnitsLength: 0,
  organizationalUnitError: ""

};

export default function ResponsibleFactorReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_RESPONSIBLEFACTOR:
      return { ...state, loading: action.payload };
    case actions.SAVE_LOADING_RESPONSIBLEFACTOR:
      return { ...state, saveLoading: action.payload };
    case actions.GET_RESPONSIBLEFACTOR:
      return {
        ...state,
        responsiblesFactors: action.payload.responsiblesFactors,
        responsiblesFactorsLength: action.payload.responsiblesFactorsLength
      };
    case actions.GET_RESPONSIBLEFACTOR_BY_ID:
      return { ...state, responsibleFactor: action.payload };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.RESPONSIBLEFACTOR_FAIL:
      return { ...state, responsibleFactorError: action.payload };

    //unidades
    case actions.LOADING_ORGANIZATIONALUNIT:
      return { ...state, loadingOrganizationalUnit: action.payload };

    case actions.GET_ORGANIZATIONALUNIT:
      return {
        ...state,
        organizationalUnits: action.payload.organizationalUnits,
        organizationalUnitsLength: action.payload.organizationalUnitsLength,
      };
    case actions.ORGANIZATIONALUNIT_FAIL:
      return { ...state, organizationalUnitError: action.payload };

    //factores criterios
    case actions.LOADING_FACTORCRITERION:
      return { ...state, loadingFactorCriterion: action.payload };
    
    case actions.GET_FACTORCRITERION:
      return {
        ...state,
        factorsCriteria: action.payload.factorsCriteria,
        factorsCriteriaLength: action.payload.factorsCriteriaLength,
      };
    case actions.FACTORCRITERION_FAIL:
      return { ...state, factorCriterionError: action.payload };



   
    default:
      return state;
  }
}
